const COUNTRIES = [
    {
        countryCode: "at",
        isoCountryCode: "at",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "de",
        unit: "int",
    },
    {
        countryCode: "au",
        isoCountryCode: "au",
        region: "Oceania",
        area: "AU",
        currency: "AUD",
        cegidCountryCode: "au",
        unit: "int",
    },
    {
        countryCode: "be",
        isoCountryCode: "be",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "be",
        unit: "int",
    },
    {
        countryCode: "br",
        isoCountryCode: "br",
        region: "South America",
        area: "BR",
        currency: "BRL",
        cegidCountryCode: "br",
        unit: "int",
    },
    {
        countryCode: "ca",
        isoCountryCode: "ca",
        region: "North America",
        area: "CA",
        currency: "CAD",
        cegidCountryCode: "ca",
        unit: "int",
    },
    {
        countryCode: "ch",
        isoCountryCode: "ch",
        region: "Europe",
        area: "EU",
        currency: "CHF",
        cegidCountryCode: "ch",
        unit: "int",
    },
    {
        countryCode: "cn",
        isoCountryCode: "cn",
        region: "Asia",
        area: "CN",
        currency: "CNY",
        cegidCountryCode: "cn",
        unit: "int",
    },
    {
        countryCode: "cz",
        isoCountryCode: "cz",
        region: "Europe",
        area: "EU",
        currency: "CZK",
        cegidCountryCode: "cz",
        unit: "int",
    },
    {
        countryCode: "de",
        isoCountryCode: "de",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "de",
        unit: "int",
    },
    {
        countryCode: "dh",
        isoCountryCode: "ae",
        region: "Middle East",
        area: "AS",
        currency: "AED",
        cegidCountryCode: "ae",
        unit: "int",
    },
    {
        countryCode: "dk",
        isoCountryCode: "dk",
        region: "Europe",
        area: "EU",
        currency: "DKK",
        cegidCountryCode: "dk",
        unit: "int",
    },
    {
        countryCode: "es",
        isoCountryCode: "es",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "es",
        unit: "int",
    },
    {
        countryCode: "fi",
        isoCountryCode: "fi",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "fr", // Finland uses "FR" cegid country code for the prices
        unit: "int",
    },
    {
        countryCode: "fr",
        isoCountryCode: "fr",
        region: "Europe",
        area: "FR",
        currency: "EUR",
        cegidCountryCode: "fr",
        unit: "int",
    },
    {
        countryCode: "hk",
        isoCountryCode: "hk",
        region: "Asia",
        area: "HK",
        currency: "HKD",
        cegidCountryCode: "hk",
        unit: "int",
    },
    {
        countryCode: "ie",
        isoCountryCode: "ie",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "ie",
        unit: "int",
    },
    {
        countryCode: "it",
        isoCountryCode: "it",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "it",
        unit: "int",
    },
    {
        countryCode: "jp",
        isoCountryCode: "jp",
        region: "Asia",
        area: "JP",
        currency: "JPY",
        cegidCountryCode: "jp",
        unit: "int",
    },
    {
        countryCode: "kr",
        isoCountryCode: "kr",
        region: "Asia",
        area: "KR",
        currency: "KRW",
        cegidCountryCode: "kr",
        unit: "int",
    },
    {
        countryCode: "lu",
        isoCountryCode: "lu",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "fr", // Luxembourg uses "FR" cegid country code for the prices
        unit: "int",
    },
    {
        countryCode: "mo",
        isoCountryCode: "mo",
        region: "Asia",
        area: "HK",
        currency: "MOP",
        cegidCountryCode: "mo",
        unit: "int",
    },
    {
        countryCode: "mx",
        isoCountryCode: "mx",
        region: "North America",
        area: "MX",
        currency: "MXN",
        cegidCountryCode: "mx",
        unit: "int",
    },
    {
        countryCode: "my",
        isoCountryCode: "my",
        region: "Asia",
        area: "AS",
        currency: "MYR",
        cegidCountryCode: "my",
        unit: "int",
    },
    {
        countryCode: "nl",
        isoCountryCode: "nl",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "nl",
        unit: "int",
    },
    {
        countryCode: "no",
        isoCountryCode: "no",
        region: "Europe",
        area: "EU",
        currency: "NOK",
        cegidCountryCode: "no",
        unit: "int",
    },
    {
        countryCode: "pl",
        isoCountryCode: "pl",
        region: "Europe",
        area: "EU",
        currency: "PLN",
        cegidCountryCode: "pl",
        unit: "int",
    },
    {
        countryCode: "pt",
        isoCountryCode: "pt",
        region: "Europe",
        area: "EU",
        currency: "EUR",
        cegidCountryCode: "pt",
        unit: "int",
    },
    {
        countryCode: "ri",
        isoCountryCode: "sa",
        region: "Middle East",
        area: "AS",
        currency: "SAR",
        cegidCountryCode: "sa",
        unit: "int",
    },
    {
        countryCode: "se",
        isoCountryCode: "se",
        region: "Europe",
        area: "EU",
        currency: "SEK",
        cegidCountryCode: "se",
        unit: "int",
    },
    {
        countryCode: "sg",
        isoCountryCode: "sg",
        region: "Asia",
        area: "AS",
        currency: "SGD",
        cegidCountryCode: "sg",
        unit: "int",
    },
    {
        countryCode: "th",
        isoCountryCode: "th",
        region: "Asia",
        area: "TH",
        currency: "THB",
        cegidCountryCode: "th",
        unit: "int",
    },
    {
        countryCode: "tw",
        isoCountryCode: "tw",
        region: "Asia",
        area: "TW",
        currency: "TWD",
        cegidCountryCode: "tw",
        unit: "int",
    },
    {
        countryCode: "uk",
        isoCountryCode: "gb",
        region: "Europe",
        area: "UK",
        currency: "GBP",
        cegidCountryCode: "gb",
        unit: "int",
    },
    {
        countryCode: "us",
        isoCountryCode: "us",
        region: "North America",
        area: "US",
        currency: "USD",
        cegidCountryCode: "us",
        unit: "imp",
    },
];

const LANGS = [
    {
        langCode: "de",
        dacCode: "de",
        pimCode: "de_DE",
        ezPublishCode: "ger-DE",
        drupalCode: "de",
        urlPrefix: "/de",
        slugify: true,
    },
    {
        langCode: "en",
        dacCode: "en",
        pimCode: "en_US",
        ezPublishCode: "eng-GB",
        drupalCode: "en-he",
        urlPrefix: "/en",
        slugify: true,
    },
    {
        langCode: "es",
        dacCode: "es",
        pimCode: "es_ES",
        ezPublishCode: "esl-ES",
        drupalCode: "es",
        urlPrefix: "/es",
        slugify: true,
    },
    {
        langCode: "fr",
        dacCode: "fr",
        pimCode: "fr_FR",
        ezPublishCode: "fre-FR",
        drupalCode: "fr",
        urlPrefix: "/fr",
        slugify: true,
    },
    {
        langCode: "it",
        dacCode: "it",
        pimCode: "it_IT",
        ezPublishCode: "ita-IT",
        drupalCode: "it",
        urlPrefix: "/it",
        slugify: true,
    },
    {
        langCode: "ja",
        dacCode: "ja",
        pimCode: "ja_JP",
        ezPublishCode: "jpn-JP",
        drupalCode: "ja",
        urlPrefix: "/ja",
        slugify: false,
    },
    {
        langCode: "ko",
        dacCode: "ko",
        pimCode: "ko_KR",
        ezPublishCode: "kor-KR",
        drupalCode: "ko",
        urlPrefix: "/ko",
        slugify: false,
    },
    {
        langCode: "pt",
        dacCode: "pt",
        pimCode: "pt_BR",
        ezPublishCode: "por-BR",
        drupalCode: "pt",
        urlPrefix: "/pt",
        slugify: true,
    },
    {
        langCode: "zh-Hans",
        dacCode: "zh",
        pimCode: "zh_CN",
        ezPublishCode: "chi-CN",
        drupalCode: "zh",
        urlPrefix: "/zh",
        slugify: false,
    },
    {
        langCode: "zh-Hant",
        dacCode: "zh",
        pimCode: "zh_TW",
        ezPublishCode: "chi-TW",
        drupalCode: "zh-tw",
        urlPrefix: "/zh",
        slugify: false,
    },
];

const DEFAULT_LOCALE = {
    countryCode: "us",
    isoCountryCode: "us",
    langCode: "en",
    code: "us_en",
    id: "en",
    hreflang: "en-us",
    urlPrefix: "/us/en",
};
const LOCALES = [
    DEFAULT_LOCALE,
    {
        countryCode: "at",
        isoCountryCode: "at",
        langCode: "de",
        code: "at_de",
        id: "de-AT",
        hreflang: "de-at",
        urlPrefix: "/at/de",
    },
    {
        countryCode: "au",
        isoCountryCode: "au",
        langCode: "en",
        code: "au_en",
        id: "en-AU",
        hreflang: "en-au",
        urlPrefix: "/au/en",
    },
    {
        countryCode: "be",
        isoCountryCode: "be",
        langCode: "en",
        code: "be_en",
        id: "en-BE",
        hreflang: "en-be",
        urlPrefix: "/be/en",
    },
    {
        countryCode: "be",
        isoCountryCode: "be",
        langCode: "fr",
        code: "be_fr",
        id: "fr-BE",
        hreflang: "fr-be",
        urlPrefix: "/be/fr",
    },
    {
        countryCode: "br",
        isoCountryCode: "br",
        langCode: "pt",
        code: "br_pt",
        id: "pt",
        hreflang: "pt-br",
        urlPrefix: "/br/pt",
    },
    {
        countryCode: "ca",
        isoCountryCode: "ca",
        langCode: "en",
        code: "ca_en",
        id: "en-CA",
        hreflang: "en-ca",
        urlPrefix: "/ca/en",
    },
    {
        countryCode: "ca",
        isoCountryCode: "ca",
        langCode: "fr",
        code: "ca_fr",
        id: "fr-CA",
        hreflang: "fr-ca",
        urlPrefix: "/ca/fr",
    },
    {
        countryCode: "ch",
        isoCountryCode: "ch",
        langCode: "de",
        code: "ch_de",
        id: "de-CH",
        hreflang: "de-ch",
        urlPrefix: "/ch/de",
    },
    {
        countryCode: "ch",
        isoCountryCode: "ch",
        langCode: "fr",
        code: "ch_fr",
        id: "fr-CH",
        hreflang: "fr-ch",
        urlPrefix: "/ch/fr",
    },
    {
        countryCode: "cn",
        isoCountryCode: "cn",
        langCode: "en",
        code: "cn_en",
        id: "en-CN",
        hreflang: "en-cn",
        urlPrefix: "/cn/en",
    },
    {
        countryCode: "cn",
        isoCountryCode: "cn",
        langCode: "zh-Hans",
        code: "cn_zh",
        id: "zh-Hans",
        hreflang: "zh-Hans-cn",
        urlPrefix: "/cn/zh",
    },
    {
        countryCode: "cz",
        isoCountryCode: "cz",
        langCode: "en",
        code: "cz_en",
        id: "en-CZ",
        hreflang: "en-cz",
        urlPrefix: "/cz/en",
    },
    {
        countryCode: "de",
        isoCountryCode: "de",
        langCode: "de",
        code: "de_de",
        id: "de",
        hreflang: "de-de",
        urlPrefix: "/de/de",
    },
    {
        countryCode: "dh",
        isoCountryCode: "ae",
        langCode: "en",
        code: "dh_en",
        id: "en-AE",
        hreflang: "en-ae",
        urlPrefix: "/dh/en",
    },
    {
        countryCode: "dk",
        isoCountryCode: "dk",
        langCode: "en",
        code: "dk_en",
        id: "en-DK",
        hreflang: "en-dk",
        urlPrefix: "/dk/en",
    },
    {
        countryCode: "es",
        isoCountryCode: "es",
        langCode: "es",
        code: "es_es",
        id: "es",
        hreflang: "es-es",
        urlPrefix: "/es/es",
    },
    {
        countryCode: "fi",
        isoCountryCode: "fi",
        langCode: "en",
        code: "fi_en",
        id: "en-FI",
        hreflang: "en-fi",
        urlPrefix: "/fi/en",
    },
    {
        countryCode: "fr",
        isoCountryCode: "fr",
        langCode: "fr",
        code: "fr_fr",
        id: "fr",
        hreflang: "fr-fr",
        urlPrefix: "/fr/fr",
    },
    {
        countryCode: "hk",
        isoCountryCode: "hk",
        langCode: "en",
        code: "hk_en",
        id: "en-HK",
        hreflang: "en-hk",
        urlPrefix: "/hk/en",
    },
    {
        countryCode: "ie",
        isoCountryCode: "ie",
        langCode: "en",
        code: "ie_en",
        id: "en-IE",
        hreflang: "en-ie",
        urlPrefix: "/ie/en",
    },
    {
        countryCode: "it",
        isoCountryCode: "it",
        langCode: "it",
        code: "it_it",
        id: "it",
        hreflang: "it-it",
        urlPrefix: "/it/it",
    },
    {
        countryCode: "jp",
        isoCountryCode: "jp",
        langCode: "ja",
        code: "jp_ja",
        id: "ja",
        hreflang: "ja-jp",
        urlPrefix: "/jp/ja",
    },
    {
        countryCode: "kr",
        isoCountryCode: "kr",
        langCode: "ko",
        code: "kr_ko",
        id: "ko",
        hreflang: "ko-kr",
        urlPrefix: "/kr/ko",
    },
    {
        countryCode: "lu",
        isoCountryCode: "lu",
        langCode: "fr",
        code: "lu_fr",
        id: "fr-LU",
        hreflang: "fr-lu",
        urlPrefix: "/lu/fr",
    },
    {
        countryCode: "mo",
        isoCountryCode: "mo",
        langCode: "en",
        code: "mo_en",
        id: "en-MO",
        hreflang: "en-mo",
        urlPrefix: "/mo/en",
    },
    {
        countryCode: "mx",
        isoCountryCode: "mx",
        langCode: "es",
        code: "mx_es",
        id: "es-MX",
        hreflang: "es-mx",
        urlPrefix: "/mx/es",
    },
    {
        countryCode: "my",
        isoCountryCode: "my",
        langCode: "en",
        code: "my_en",
        id: "en-MY",
        hreflang: "en-my",
        urlPrefix: "/my/en",
    },
    {
        countryCode: "nl",
        isoCountryCode: "nl",
        langCode: "en",
        code: "nl_en",
        id: "en-NL",
        hreflang: "en-nl",
        urlPrefix: "/nl/en",
    },
    {
        countryCode: "no",
        isoCountryCode: "no",
        langCode: "en",
        code: "no_en",
        id: "en-NO",
        hreflang: "en-no",
        urlPrefix: "/no/en",
    },
    {
        countryCode: "pl",
        isoCountryCode: "pl",
        langCode: "en",
        code: "pl_en",
        id: "en-PL",
        hreflang: "en-pl",
        urlPrefix: "/pl/en",
    },
    {
        countryCode: "pt",
        isoCountryCode: "pt",
        langCode: "en",
        code: "pt_en",
        id: "en-PT",
        hreflang: "en-pt",
        urlPrefix: "/pt/en",
    },
    {
        countryCode: "ri",
        isoCountryCode: "sa",
        langCode: "en",
        code: "ri_en",
        id: "en-SA",
        hreflang: "en-sa",
        urlPrefix: "/ri/en",
    },
    {
        countryCode: "se",
        isoCountryCode: "se",
        langCode: "en",
        code: "se_en",
        id: "en-SE",
        hreflang: "en-se",
        urlPrefix: "/se/en",
    },
    {
        countryCode: "sg",
        isoCountryCode: "sg",
        langCode: "en",
        code: "sg_en",
        id: "en-SG",
        hreflang: "en-sg",
        urlPrefix: "/sg/en",
    },
    {
        countryCode: "th",
        isoCountryCode: "th",
        langCode: "en",
        code: "th_en",
        id: "en-TH",
        hreflang: "en-th",
        urlPrefix: "/th/en",
    },
    {
        countryCode: "tw",
        isoCountryCode: "tw",
        langCode: "zh-Hant",
        code: "tw_zh",
        id: "zh-Hant",
        hreflang: "zh-Hant-tw",
        urlPrefix: "/tw/zh",
    },
    {
        countryCode: "uk",
        isoCountryCode: "gb",
        langCode: "en",
        code: "uk_en",
        id: "en-GB",
        hreflang: "en-gb",
        urlPrefix: "/uk/en",
    },
];
const X_DEFAULT = "x-default";

var Tax;
(function (Tax) {
    Tax["TTC"] = "TTC";
    Tax["HT"] = "HT";
})(Tax || (Tax = {}));
const CEGID_COUNTRIES = [
    {
        code: "de",
        tax: Tax.TTC,
    },
    {
        code: "au",
        tax: Tax.TTC,
    },
    {
        code: "be",
        tax: Tax.TTC,
    },
    {
        code: "br",
        tax: Tax.TTC,
    },
    {
        code: "ca",
        tax: Tax.HT,
    },
    {
        code: "ch",
        tax: Tax.TTC,
    },
    {
        code: "cn",
        tax: Tax.TTC,
    },
    {
        code: "cz",
        tax: Tax.TTC,
    },
    {
        code: "ae",
        tax: Tax.TTC,
    },
    {
        code: "dk",
        tax: Tax.TTC,
    },
    {
        code: "es",
        tax: Tax.TTC,
    },
    {
        code: "fr",
        tax: Tax.TTC,
    },
    {
        code: "hk",
        tax: Tax.TTC,
    },
    {
        code: "ie",
        tax: Tax.TTC,
    },
    {
        code: "it",
        tax: Tax.TTC,
    },
    {
        code: "jp",
        tax: Tax.TTC,
    },
    {
        code: "kr",
        tax: Tax.TTC,
    },
    {
        code: "mo",
        tax: Tax.TTC,
    },
    {
        code: "mx",
        tax: Tax.TTC,
    },
    {
        code: "my",
        tax: Tax.TTC,
    },
    {
        code: "nl",
        tax: Tax.TTC,
    },
    {
        code: "no",
        tax: Tax.TTC,
    },
    {
        code: "pl",
        tax: Tax.TTC,
    },
    {
        code: "pt",
        tax: Tax.TTC,
    },
    {
        code: "sa",
        tax: Tax.TTC,
    },
    {
        code: "se",
        tax: Tax.TTC,
    },
    {
        code: "sg",
        tax: Tax.TTC,
    },
    {
        code: "th",
        tax: Tax.TTC,
    },
    {
        code: "tw",
        tax: Tax.TTC,
    },
    {
        code: "gb",
        tax: Tax.TTC,
    },
    {
        code: "us",
        tax: Tax.HT,
    },
];

const isoCodesToHermes = {
    gb: "uk",
    ae: "dh",
    sa: "ri",
};
const countryFromCode = (code) => COUNTRIES.find((country) => country.countryCode === code) ??
    (() => {
        throw new Error(`No country matching code ${code}`);
    })();
const transformIsoCodeToCountryCode = (countryCode) => {
    if (Object.keys(isoCodesToHermes).includes(countryCode)) {
        return isoCodesToHermes[countryCode].toUpperCase();
    }
    return countryCode;
};
const regionFromCode = (code) => countryFromCode(code).region;
const currencyFromCegidCountryCode = (cegidCountryCode) => COUNTRIES.find((country) => country.cegidCountryCode === cegidCountryCode)
    ?.currency ??
    (() => {
        throw new Error(`No country matching with this cegidCountryCode : ${cegidCountryCode}`);
    })();
const countriesInRegion = (region) => COUNTRIES.filter((country) => country.region === region);
const countriesFromArea = (area) => COUNTRIES.filter((country) => country.area === area);
const countriesFromCurrency = (currency) => COUNTRIES.filter((country) => country.currency === currency);
const countriesFromUnit = (unit) => COUNTRIES.filter((country) => country.unit === unit);
const isEurope = (country) => country.region === "Europe";
const isMiddleEast = (country) => country.region === "Middle East";
const isNorthAmerica = (country) => country.region === "North America";
const isSouthAmerica = (country) => country.region === "South America";
const isAsia = (country) => country.region === "Asia";
const isOceania = (country) => country.region === "Oceania";
const isAustria = (parameter) => parameter.countryCode === "at";
const isAustralia = (parameter) => parameter.countryCode === "au";
const isBelgium = (parameter) => parameter.countryCode === "be";
const isBrazil = (parameter) => parameter.countryCode === "br";
const isCanada = (parameter) => parameter.countryCode === "ca";
const isChina = (parameter) => parameter.countryCode === "cn";
const isCzechRepublic = (parameter) => parameter.countryCode === "cz";
const isDenmark = (parameter) => parameter.countryCode === "dk";
const isFinland = (parameter) => parameter.countryCode === "fi";
const isFrance = (parameter) => parameter.countryCode === "fr";
const isGermany = (parameter) => parameter.countryCode === "de";
const isHongKong = (parameter) => parameter.countryCode === "hk";
const isIreland = (parameter) => parameter.countryCode === "ie";
const isItalia = (parameter) => parameter.countryCode === "it";
const isJapan = (parameter) => parameter.countryCode === "jp";
const isKorea = (parameter) => parameter.countryCode === "kr";
const isLuxembourg = (parameter) => parameter.countryCode === "lu";
const isMacau = (parameter) => parameter.countryCode === "mo";
const isMalaysia = (parameter) => parameter.countryCode === "my";
const isNetherlands = (parameter) => parameter.countryCode === "nl";
const isNorway = (parameter) => parameter.countryCode === "no";
const isPoland = (parameter) => parameter.countryCode === "pl";
const isPortugal = (parameter) => parameter.countryCode === "pt";
const isSaudiArabia = (parameter) => parameter.countryCode === "ri";
const isSingapore = (parameter) => parameter.countryCode === "sg";
const isSpain = (parameter) => parameter.countryCode === "es";
const isSweden = (parameter) => parameter.countryCode === "se";
const isSwitzerland = (parameter) => parameter.countryCode === "ch";
const isTaiwan = (parameter) => parameter.countryCode === "tw";
const isThailand = (parameter) => parameter.countryCode === "th";
const isUnitedArabEmirates = (parameter) => parameter.countryCode === "dh";
const isUnitedKingdom = (parameter) => parameter.countryCode === "uk";
const isUsa = (parameter) => parameter.countryCode === "us";
const isMexico = (parameter) => parameter.countryCode === "mx";

const langFromCode = (code) => LANGS.find((lang) => lang.langCode === code) ??
    (() => {
        throw new Error(`No lang matching code ${code}`);
    })();
const langFromDrupalCode = (drupalCode) => LANGS.find((lang) => lang.drupalCode === drupalCode) ??
    (() => {
        throw new Error(`No lang matching drupalCode ${drupalCode}`);
    })();
const langFromEzPublishCode = (ezPublishCode) => LANGS.find((lang) => lang.ezPublishCode === ezPublishCode) ??
    (() => {
        throw new Error(`No lang matching ezPublishCode ${ezPublishCode}`);
    })();
const langFromPimCode = (pimCode) => LANGS.find((lang) => lang.pimCode === pimCode) ??
    (() => {
        throw new Error(`No lang matching pimCode ${pimCode}`);
    })();
// FIXME Rollout : One code in DAC should match only one lang
const langMatchingDacCode = (dacCode) => LANGS.filter((lang) => lang.dacCode === dacCode);
const isSimplifiedChinese = (parameter) => parameter.langCode === "zh-Hans";
const isTraditionalChinese = (parameter) => parameter.langCode === "zh-Hant";
const isEnglish = (parameter) => parameter.langCode === "en";
const isFrench = (parameter) => parameter.langCode === "fr";
const isGerman = (parameter) => parameter.langCode === "de";
const isItalian = (parameter) => parameter.langCode === "it";
const isJapanese = (parameter) => parameter.langCode === "ja";
const isKorean = (parameter) => parameter.langCode === "ko";
const isPortuguese = (parameter) => parameter.langCode === "pt";
const isSpanish = (parameter) => parameter.langCode === "es";

const localeFromCountryLang = (countryCode, langCode) => LOCALES.find((locale) => locale.countryCode === countryCode && locale.langCode === langCode) ??
    (() => {
        throw new Error(`No locale matching countryCode ${countryCode} and langCode ${langCode}`);
    })();
const localeFromCode = (code) => LOCALES.find((locale) => locale.code === code) ??
    (() => {
        throw new Error(`No locale matching code ${code}`);
    })();
const localeFromCodeUnsafe = (code) => LOCALES.find((locale) => locale.code === code);
const localeFromId = (id) => LOCALES.find((locale) => locale.id === id) ?? DEFAULT_LOCALE;
const localeFromUrlPrefix = (urlPrefix) => LOCALES.find((locale) => locale.urlPrefix === urlPrefix) ??
    (() => {
        throw new Error(`No locale matching prefix ${urlPrefix}`);
    })();
const localeFromUrlPrefixUnsafe = (urlPrefix) => LOCALES.find((locale) => locale.urlPrefix === urlPrefix);
const localeFromHrefLang = (hreflang) => hreflang === X_DEFAULT
    ? DEFAULT_LOCALE
    : LOCALES.find((locale) => locale.hreflang === hreflang) ??
        (() => {
            throw new Error(`No locale matching hreflang ${hreflang}`);
        })();
const localeXDefault = () => DEFAULT_LOCALE;
const localesMatchingCountry = (countryCode) => LOCALES.filter((locale) => locale.countryCode === countryCode);
const localesMatchingLang = (langCode) => LOCALES.filter((locale) => locale.langCode === langCode);

export { CEGID_COUNTRIES, COUNTRIES, DEFAULT_LOCALE, LANGS, LOCALES, Tax, X_DEFAULT, countriesFromArea, countriesFromCurrency, countriesFromUnit, countriesInRegion, countryFromCode, currencyFromCegidCountryCode, isAsia, isAustralia, isAustria, isBelgium, isBrazil, isCanada, isChina, isCzechRepublic, isDenmark, isEnglish, isEurope, isFinland, isFrance, isFrench, isGerman, isGermany, isHongKong, isIreland, isItalia, isItalian, isJapan, isJapanese, isKorea, isKorean, isLuxembourg, isMacau, isMalaysia, isMexico, isMiddleEast, isNetherlands, isNorthAmerica, isNorway, isOceania, isPoland, isPortugal, isPortuguese, isSaudiArabia, isSimplifiedChinese, isSingapore, isSouthAmerica, isSpain, isSpanish, isSweden, isSwitzerland, isTaiwan, isThailand, isTraditionalChinese, isUnitedArabEmirates, isUnitedKingdom, isUsa, langFromCode, langFromDrupalCode, langFromEzPublishCode, langFromPimCode, langMatchingDacCode, localeFromCode, localeFromCodeUnsafe, localeFromCountryLang, localeFromHrefLang, localeFromId, localeFromUrlPrefix, localeFromUrlPrefixUnsafe, localeXDefault, localesMatchingCountry, localesMatchingLang, regionFromCode, transformIsoCodeToCountryCode };
